function importAll(r) {
  r.keys().forEach(r);
}
importAll(require.context("../../icons", false, /\.svg$/));

import Main from "./main";
export default Main;
